export default {
  networkStatus: {
    offline: 'вы работаете в оффлайн режиме',
    online: 'вы снова онлайн',
  },
}
